import * as React from 'react';
import { observer } from 'mobx-react';
import { LongSectionStore } from '@pages/cross-section/long-section/LongSectionStore';
import { CrossSectionStore } from '@pages/cross-section/cross-section/CrossSectionStore';
import { Button } from '@shared/ui-react/Button';

export const CrossSectionZoomComponent: React.FC<{ store: CrossSectionStore | LongSectionStore }> = observer(({ store }) => {
    return <div className="toolbar-group">
        <div className="btn-group">
            <Button id="zoomReset" icon="iki-fit-to-screen" onClick={store.csCanvas.zoomReset}/>
            <Button id="zoomOut" icon="iki-minus" onClick={() => store.csCanvas.zoomOut()}/>
            <Button id="zoomIn" icon="iki-plus" onClick={() => store.csCanvas.zoomIn()}/>
        </div>

        <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 10 }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', margin: 'auto', padding: '0 5px', minWidth: "6em", justifyContent: 'flex-end' }}>y-Scale 1:
                <div>{store.csCanvas.yScale}</div>
            </div>
            <Button icon='iki-chevron-left' onClick={store.csCanvas.yScaleDecrease}/>
            <Button icon='iki-chevron-right' onClick={store.csCanvas.yScaleIncrease}/>
        </div>
    </div>
})
